import React, { Fragment } from 'react';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import UpdateDB from '../../../Component/Assets/AddAsset/UpdateDB';

const UpdateDBB = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Assets" title="Update Distribution Board" />
            <UpdateDB />
        </Fragment>
    );
};
export default UpdateDBB;